import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import athleteApi from '@/lib/api'

// Upload video for milestone
export const uploadVideoForMilestone = createAsyncThunk<
  { uploadId: number; url: string },
  {
    campaignId: string
    milestoneId: number
    file: File
    onProgress?: (progress: number) => void
  },
  { rejectValue: string }
>(
  'campaigns/uploadVideoForMilestone',
  async ({ campaignId, milestoneId, file, onProgress }, { rejectWithValue }) => {
    try {
      // Step 1: Get presigned upload URL
      const urlResponse = await athleteApi.post(
        `/athlete/campaigns/${campaignId}/milestones/${milestoneId}/upload-url`,
        {
          filename: file.name,
          contentType: file.type,
        },
      )

      const { uploadUrl, key, bucket } = urlResponse.data

      // Step 2: Upload file to S3 using presigned URL
      await axios.put(uploadUrl, file, {
        headers: {
          'Content-Type': file.type,
          'x-amz-acl': 'public-read',
        },
        onUploadProgress: (progressEvent) => {
          if (!onProgress) return
          const total = progressEvent.total ?? file.size
          if (!total) return
          const percentCompleted = Math.round((progressEvent.loaded * 100) / total)
          onProgress(percentCompleted)
        },
      })

      // Step 3: Track upload in database
      const trackResponse = await athleteApi.post(
        `/athlete/campaigns/${campaignId}/milestones/${milestoneId}/track-upload`,
        {
          key,
          bucket,
          filename: file.name,
          fileSize: file.size,
          contentType: file.type,
        },
      )

      return {
        uploadId: trackResponse.data.id,
        url: trackResponse.data.url,
      }
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.error || error.message || 'Failed to upload video',
      )
    }
  },
)
